import { orderBy, filter } from 'lodash-es'
import { FilterCheckbox } from './FilterModel'

export const sortRows = (
  rows: any[],
  sortByKey: string,
  sortDirection: string
) => {
  try {
    return orderBy(rows, [sortByKey], [sortDirection])
  } catch (error) {
    return rows
  }
}

export const createFilterObject = (selectedFilters: FilterCheckbox[]) => {
  const filterObject = {}
  selectedFilters.forEach((filterCheckboxObject) => {
    if (!filterObject[filterCheckboxObject.key]) {
      filterObject[filterCheckboxObject.key] = [filterCheckboxObject.value]
    } else {
      filterObject[filterCheckboxObject.key] = [
        ...filterObject[filterCheckboxObject.key],
        filterCheckboxObject.value,
      ]
    }
  })
  return filterObject
}

/*
The filterObject will be like
  {
    "city": [
      "Los Angeles",
      "San Francisco"
    ],
    "archived": [
      false
    ]
  }
*/
export const filterRows = (rows: any[], selectedFilters: FilterCheckbox[]) => {
  try {
    // Getting the filter object
    const filterObject = createFilterObject(selectedFilters)
    return filter(rows, (row) => {
      return Object.keys(filterObject).every((key) => {
        // If the key is an array
        if (Array.isArray(row[key])) {
          return filterObject[key].every((filterValue) =>
            row[key].includes(filterValue)
          )
        } else {
          return filterObject[key].includes(row[key])
        }
      })
    })
  } catch (error) {
    return rows
  }
}

export const searchRows = (
  rows: any[],
  keys: string[],
  searchValue: string
) => {
  return filter(rows, (row) => {
    return keys.some((key) => {
      return String(row[key] ?? '')
        .toLowerCase()
        .includes(searchValue.toLowerCase())
    })
  })
}

/*
  The customCell row array is like
  [
    [
      {
          "text": "1142",
          "customCell": null
      },
      {
          "text": "Duane Gorczany",
          "customCell": null
      },
      {
          "text": "duane_gorczany_med@movewithfleet.com",
          "customCell": null
      },
      {
          "text": "HQ",
          "customCell": null
      },
      {
          "text": "February 2025",
          "customCell": null
      },
      {
          "text": 100,
          "customCell": "Currency"
      },
      {
          "text": 100,
          "customCell": "Currency"
      }
    ],
    ....
  ]
*/
export const searchCustomCellRows = (
  rows: any[],
  searchColumnNumbers: number[],
  searchValue: string
) => {
  try {
    return filter(rows, (row) => {
      return searchColumnNumbers.some((columnNumber) => {
        return row[columnNumber].text
          .toLowerCase()
          .includes(searchValue.toLowerCase())
      })
    })
  } catch (error) {
    return rows
  }
}

export const sortCustomCellRows = (
  rows: any[],
  sortColumnNumber: number,
  sortDirection: string
) => {
  try {
    return orderBy(
      rows,
      (row) => {
        return row[sortColumnNumber].text
      },
      [sortDirection]
    )
  } catch (error) {
    return rows
  }
}

export const filterCustomCellRows = (
  rows: any[],
  selectedFilters: FilterCheckbox[]
) => {
  try {
    const filterObject = createFilterObject(selectedFilters)
    return filter(rows, (row) => {
      return Object.keys(filterObject).every((columnIndex) => {
        const arrayValues = filterObject[columnIndex]
        const rowValue = row[columnIndex].text
        return arrayValues.every((filterValue) =>
          rowValue.includes(filterValue)
        )
      })
    })
  } catch (error) {
    return rows
  }
}
